import { render } from "./DataIngestionHistoryMenuSkeleton.vue?vue&type=template&id=258920da&scoped=true"
const script = {}

import "./DataIngestionHistoryMenuSkeleton.vue?vue&type=style&index=0&id=258920da&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258920da"]])

export default __exports__